import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/Accordion";
import { cn } from "@/util/cn";

type GasInformationAccordionProps = {
  defaultOpen?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export default function GasInformationAccordion({
  defaultOpen,
  open,
  onOpenChange,
}: GasInformationAccordionProps) {
  const handleValueChange = (value: string) => {
    onOpenChange?.(value === "item-1");
  };

  return (
    <Accordion
      type="single"
      collapsible={!defaultOpen}
      className="w-full"
      value={open ? "item-1" : ""}
      onValueChange={handleValueChange}
      defaultValue={defaultOpen ? "item-1" : undefined}
    >
      <AccordionItem value="item-1" className="mt-4 mx-auto max-w-lg">
        <AccordionTrigger
          className={cn("hover:no-underline ", defaultOpen && "[&>svg]:hidden")}
        >
          <p className="font-semibold">
            Yes, you can use your SolarCloud panels to pay your electricity
            and/or gas bills.
          </p>
        </AccordionTrigger>
        <AccordionContent className="space-y-4">
          <p className="">
            The credits (technically disbursements) generated by your SolarCloud
            panels can be applied to either:
          </p>
          <ul className="list-disc px-10">
            <li className="font-semibold">Your electricity bill</li>
            <li className="font-semibold">Your gas bill, or</li>
            <li>
              <span className="font-semibold">Split between both</span> —
              meaning some credits go toward your electricity account and the
              rest toward your gas account.
            </li>
          </ul>
          <p>
            Please note: we recommend seeking independent tax advice regarding
            how these credits may be treated in your situation.
          </p>
          <p>
            To get started, please have a copy of your gas bill ready, as we'll
            need a few details to ensure the credits are allocated correctly.
          </p>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
